export default __webpack_public_path__ + "static/media/Web3Games-hover.acdbdb44.png";